module.exports = __webpack_public_path__ + "images/emoji_22bde2341de85c9ccd627bf47e88d2c60.svg";